import { useMemo, useState } from 'react'

import Paper from '@/components/Paper'
import {
    DataTableCustomized,
    FilterBar,
} from '@/components/ui/data-table-customized'

import { useSyncLogList } from '../../hooks/use-sync-log-list'
import MetadataDialog from './MetadataDialog'

const AttendanceSyncLogList = () => {
    const [isDialogOpen, setIsDialogOpen] = useState(false)
    const [selectedLogId, setSelectedLogId] = useState<number | null>(null)
    const [selectedLogDate, setSelectedLogDate] = useState<string | null>(null)

    const {
        syncLogs,
        pagination,
        stateComponent,
        control,
        setFilter,
        params,
        columns,
        buildActions,
        filterItems,
        filterToggles,
        handleSortChange,
        handlePageChange,
        handlePageSizeChange,
    } = useSyncLogList()

    const handleOpenDialog = (row: any) => {
        setSelectedLogId(row.sync_log_id)
        setSelectedLogDate(row.sync_date)
        setIsDialogOpen(true)
    }

    const actions = useMemo(
        () => buildActions(handleOpenDialog),
        [buildActions]
    )

    return (
        <>
            <Paper className="space-y-2">
                <FilterBar
                    storageKey="sync-logs"
                    control={control}
                    setFilter={setFilter}
                    hideSearch
                    items={filterItems}
                />

                {stateComponent || (
                    <DataTableCustomized
                        columns={columns}
                        rows={syncLogs}
                        rowKey={(row) => String(row.sync_log_id)}
                        actions={actions}
                        size="small"
                        toolbar={{
                            settings: {
                                show: true,
                                storageKey: 'sync-logs',
                                filterToggles,
                            },
                        }}
                        sorting={{
                            sortBy: params.sort_by,
                            sortOrder: params.sort_order,
                            onSortChange: handleSortChange,
                        }}
                        pagination={{
                            page: params.page,
                            pageSize: params.page_size,
                            total: pagination?.total || 0,
                            onPageChange: handlePageChange,
                            onPageSizeChange: handlePageSizeChange,
                        }}
                    />
                )}
            </Paper>

            <MetadataDialog
                open={isDialogOpen}
                onClose={() => setIsDialogOpen(false)}
                syncLogId={selectedLogId}
                syncLogDate={selectedLogDate}
            />
        </>
    )
}

export default AttendanceSyncLogList
